import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJohndeereComponent } from './simple-icons-johndeere.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJohndeereComponent ],
    exports:      [ SimpleIconsJohndeereComponent ],
    bootstrap:    []
})
export class SimpleIconsJohndeereModule {}
